export default {
  onyx: process.env.VUE_APP_SUBDOMAIN_ADDR_ONXY || 'https://onyx.centralizedapp.site/',
  onyx_archive: process.env.VUE_APP_SUBDOMAIN_ADDR_ONXY_ARCHIVE || 'https://onyx-archive.centralizedapp.site/',
  clarity: process.env.VUE_APP_SUBDOMAIN_ADDR_CLARITY || 'https://clarity.centralizedapp.site/',
  // Add more subsystem mappings as needed
}